/**
 * Lightweight carousel for Vipelin sections
 * Usage: new VpCarousel(el, { autoplay: 5000 })
 */
class VpCarousel {
  constructor(container, opts = {}) {
    this.container = container;
    this.track = container.querySelector('[data-carousel-track]');
    this.slides = [...container.querySelectorAll('[data-carousel-slide]')];
    this.dots = [...container.querySelectorAll('[data-carousel-dot]')];
    this.current = 0;
    this.total = this.slides.length;
    this.autoplayDelay = opts.autoplay || 0;
    this.autoplayTimer = null;

    if (this.total < 2) return;

    this.bindDots();
    this.bindSwipe();
    this.goTo(0);
    if (this.autoplayDelay) this.startAutoplay();
  }

  goTo(index) {
    this.current = ((index % this.total) + this.total) % this.total;
    this.track.style.transform = `translateX(-${this.current * 100}%)`;
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
    });
  }

  next() { this.goTo(this.current + 1); }
  prev() { this.goTo(this.current - 1); }

  bindDots() {
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        this.goTo(i);
        this.resetAutoplay();
      });
    });
  }

  bindSwipe() {
    let startX = 0;
    let diff = 0;
    this.track.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      diff = 0;
    }, { passive: true });
    this.track.addEventListener('touchmove', (e) => {
      diff = e.touches[0].clientX - startX;
    }, { passive: true });
    this.track.addEventListener('touchend', () => {
      if (Math.abs(diff) > 40) {
        diff < 0 ? this.next() : this.prev();
        this.resetAutoplay();
      }
    });
  }

  startAutoplay() {
    this.autoplayTimer = setInterval(() => this.next(), this.autoplayDelay);
    this.container.addEventListener('mouseenter', () => clearInterval(this.autoplayTimer));
    this.container.addEventListener('mouseleave', () => {
      this.autoplayTimer = setInterval(() => this.next(), this.autoplayDelay);
    });
  }

  resetAutoplay() {
    if (!this.autoplayDelay) return;
    clearInterval(this.autoplayTimer);
    this.autoplayTimer = setInterval(() => this.next(), this.autoplayDelay);
  }
}
